export class DeleteRecoverRequest {
    email: string;
}
